"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACK_EVENT = void 0;
var TRACK_EVENT = '@@hublytics';
exports.TRACK_EVENT = TRACK_EVENT;